import type {ExportFormat} from '@github-ui/copilot-conversation-export/types'
import {ConversationActionsMenu} from '@github-ui/copilot-shared-ui/components/ConversationActionsMenu'
import {ConversationHeader} from '@github-ui/copilot-shared-ui/components/ConversationHeader'

import {useConversationTitleEditing} from '../providers/use-conversation-title-editing'

import {DebugLogButton} from './DebugLogButton'
import {EnvironmentSetupLoaderMenuItem} from './EnvironmentSetup/EnvironmentSetupLoaderMenuItem'

export const QUICK_CHAT_HEADING_ID = 'quick-chat-heading'

export function QuickChatHeader({
  title,
  onExport,
  isProvisioned,
  onDelete,
}: {
  title: string
  onExport: ((format: ExportFormat) => Promise<void>) | undefined
  isProvisioned: boolean
  onDelete: (() => void) | undefined
}) {
  const {isEditingTitle, renamePending, onRename, onTitleCommit, onTitleCancel} = useConversationTitleEditing()
  const onRenameWhenProvisioned = isProvisioned ? onRename : undefined

  return (
    <ConversationHeader
      title={title}
      titleId={QUICK_CHAT_HEADING_ID}
      menuItems={
        <>
          <ConversationActionsMenu onExport={onExport} onRename={onRenameWhenProvisioned} onDelete={onDelete} />
          <EnvironmentSetupLoaderMenuItem />
        </>
      }
      actions={<DebugLogButton />}
      isEditingTitle={isEditingTitle}
      renamePending={renamePending}
      onTitleCommit={onTitleCommit}
      onTitleCancel={onTitleCancel}
    />
  )
}
